/* eslint camelcase: 0 */
import { toFileProps } from './file'
import { Appointment, AppointmentDetail, AppointmentRequest, ScheduleRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IAppointmentProps, EmptyAppointmentPropsFactory } from '@/entities/Appointment'

export const toAppointmentProps = (props: Appointment | AppointmentDetail | null | undefined): IAppointmentProps => {
  if (!props) {
    return EmptyAppointmentPropsFactory()
  }

  const {
    id,
    hospital_id,
    user_id,
    doctor_id,
    user,
    hospital,
    doctor,
    reads_count,
    datetimes,
    properties,
    department,
    files,
    messages,
    status,
    is_hospital,
    is_appointment,
    is_schedule,
    is_result,
    started_at,
    ended_at,
    created_at,
    updated_at
  } = props

  return EmptyAppointmentPropsFactory({
    id,
    hospitalId: hospital_id,
    userId: user_id,
    companyId: user?.company_id,
    doctorId: doctor_id,
    user,
    hospital,
    doctor,
    readsCount: reads_count,
    datetimes,
    properties,
    department,
    files: files?.map(toFileProps),
    keeps: files?.map(toFileProps),
    messages,
    status,
    isHospital: is_hospital,
    isAppointment: is_appointment,
    isSchedule: is_schedule,
    isResult: is_result,
    startedAt: started_at,
    endedAt: ended_at,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toAppointmentRequest = (props: IAppointmentProps): AppointmentRequest => {
  const { doctorId, hospitalId, status, isSchedule, isResult, isAppointment, isHospital, datetimes, properties, data, keeps, message } = props
  return {
    doctor_id: doctorId!,
    hospital_id: hospitalId!,
    status: status!,
    is_schedule: isSchedule!,
    is_result: isResult!,
    is_appointment: isAppointment!,
    is_hospital: isHospital!,
    datetimes: JSON.stringify(datetimes),
    properties: JSON.stringify(properties),
    data: data!,
    keeps: JSON.stringify(keeps),
    message: message!
  }
}

export const toScheduleRequest = (props: IAppointmentProps): ScheduleRequest => {
  const { doctorId, hospitalId, status, isSchedule, isResult, isAppointment, isHospital, properties, data, keeps, message, startedAt, endedAt } = props
  return {
    doctor_id: doctorId!,
    hospital_id: hospitalId!,
    status: status!,
    is_schedule: isSchedule!,
    is_result: isResult!,
    is_appointment: isAppointment!,
    is_hospital: isHospital!,
    properties: JSON.stringify(properties),
    data: data!,
    keeps: JSON.stringify(keeps),
    message: message!,
    started_at: startedAt!,
    ended_at: endedAt!
  }
}
